var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95926 22.0013C9.48051 23.1735 10.6364 24 12.0005 24C13.3647 24 14.5205 23.1735 15.0418 22.0013C14.0799 22.0484 13.0796 22.08 12.0005 22.08C10.9215 22.08 9.92118 22.0483 8.95926 22.0013ZM22.5884 16.92C21.3231 15.3245 19.1996 12.1882 19.1996 9.12C19.1996 6.07777 17.245 3.34078 14.3996 2.3347C14.365 1.04062 13.3013 0 12.0005 0C10.6987 0 9.63604 1.04062 9.60145 2.3347C6.75506 3.34078 4.80051 6.07777 4.80051 9.12C4.80051 12.1891 2.67797 15.3245 1.41173 16.92C0.989342 17.4528 0.858748 18.1565 1.06326 18.8025C1.26295 19.4333 1.7602 19.9219 2.39381 20.1082C3.50358 20.4355 5.32275 20.8042 8.09718 20.9923C9.29812 21.0729 10.5893 21.12 12.0006 21.12C13.4108 21.12 14.702 21.0729 15.9029 20.9923C18.6783 20.8042 20.4966 20.4355 21.6073 20.1082C22.2409 19.9219 22.7372 19.4333 22.9369 18.8025C23.1413 18.1565 23.0098 17.4528 22.5884 16.92Z",
    fill: "#353A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.fd59e9ddbc5c8d04e5ceb86c8d064639.svg";
export { ForwardRef as ReactComponent };